export default {"src":"/_next/static/media/verifyViaOtp.4cd22b66.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};